import type { User } from '../../data/domains/profile';
import { setLoginJustHappened } from './session/postLoginSignals';
import { getAuthStore } from './store';
import { scheduleFcmBackendSync } from '../../platform/notifications/fcmBackendSync';
import { persistSessionUser } from './session/persistSessionUser';
import { resetRootNavigationForAuth } from '../../navigation/navigationRootRef';

export type CompleteSessionOptions = {
  /**
   * Default `none`: apply session synchronously so auth state + root stack remount are not lost
   * to sheet dismiss / animation timing. Pass `animationFrame` only when the caller already deferred.
   */
  defer?: 'animationFrame' | 'none';
};

/**
 * Apply authenticated user to zustand + post-login grace + session persistence.
 * Always reset root nav to MainTabs → Dashboard so guest AuthStack routes that share names with
 * MainStack (`GuestMenuPreview`, `SubscriptionList`, …) do not leave the user stuck after login.
 */
export function completeSession(user: User, options?: CompleteSessionOptions): void {
  const apply = () => {
    getAuthStore().setUser(user);
    setLoginJustHappened();
    void persistSessionUser(user);
    scheduleFcmBackendSync('completeSession');
    resetRootNavigationForAuth(true);
  };
  if (options?.defer === 'animationFrame') {
    requestAnimationFrame(apply);
    return;
  }
  apply();
}
